import moment from 'moment';
// import parse from 'date-fns/parse';
// import ar from 'date-fns/locale/ar';

export function dateFormat(value: any, formatType?: string): string {
  if(!value) return '';
  if(formatType === 'show-time') {
    return moment(value).format('D-MMM-YY (hh:mm A)');
  }
  if(formatType === 'arabic') {
    return moment(value).locale('ar').format('D-MMM-YY');
  }
  if(formatType === 'calendar') {
    return moment(value).calendar();
  }
  if(formatType === 'date-picker') {
    return moment(value).format('YYYY-MM-DD');
  }
  return moment(value).format('D-MMM-YY');
}